import { useState, type ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getReceiptFileUrl } from "../api/documents";

interface ReceiptThumbnailProps {
  receiptId: number;
  clientId: number;
}

export function ReceiptThumbnail({ receiptId, clientId }: ReceiptThumbnailProps): ReactNode {
  const [loadError, setLoadError] = useState(false);
  const fileUrl = getReceiptFileUrl(clientId, receiptId);

  function handleClick(): void {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }

  if (loadError) {
    return (
      <motion.div
        className="receipt-thumbnail receipt-thumbnail--error"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
        title="Receipt image failed to load"
      >
        <span aria-hidden="true">&#128247;</span>
      </motion.div>
    );
  }

  return (
    <AnimatePresence>
      <motion.button
        type="button"
        className="receipt-thumbnail"
        onClick={handleClick}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 20,
        }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        aria-label="View receipt full size"
        title="Click to view full-size receipt"
      >
        <img
          src={fileUrl}
          alt="Receipt thumbnail"
          className="receipt-thumbnail__image"
          onError={() => setLoadError(true)}
        />
      </motion.button>
    </AnimatePresence>
  );
}
